const imgURL = "assets/images/";

import { fileLogos, hourDayEnum, roles } from "./constant";
import { message, Modal } from "antd";
import dayjs from "dayjs";
import store from "@/redux/store";
import * as actionTypes from "@/redux/auth/types";
import storePersist from "@/redux/storePersist";
import { ExclamationCircleOutlined } from "@ant-design/icons";

const { confirm } = Modal;

/* 
 To get nested object properties.
 admin = {
    location: {
        lat: 50,
        long: 9
    }
 }

 get(admin, 'location.lat')     // 50
 get(admin, 'location.foo.bar') // undefined
*/

export function get(obj, key) {
  return key.split(".").reduce(function (o, x) {
    return o === undefined || o === null ? o : o[x];
  }, obj);

  // key.split('.').reduce(function(o, x) {
  //     return (o === undefined || o === null) ? o : o[x];
  //   }, obj);
}

Object.byString = function (o, s) {
  s = s.replace(/\[(\w+)\]/g, ".$1"); // convert indexes to properties
  s = s.replace(/^\./, ""); // strip a leading dot
  let a = s.split(".");
  for (let i = 0, n = a.length; i < n; ++i) {
    let k = a[i];
    if (o !== null) {
      if (k in o) {
        o = o[k];
      } else {
        return;
      }
    } else {
      return;
    }
  }
  return o;
};

export const truncateText = (name, maxLength = 20) => {
  if (name.length <= maxLength) return name;
  const baseName = name.substring(0, name.lastIndexOf("."));
  return `${baseName.substring(0, maxLength)}...`;
};

export function replaceElement(array, key, value, newData) {
  return [...array].map((elem, i) => {
    const check = key ? elem[key] : i;
    if (check === value) {
      if (typeof newData === "function") return newData(elem);
      // // if (elem?.image instanceof File) {
      // //   console.log("FILE DETECTED");
      // //   return newData;
      // // }
      //   if (typeof elem?.image === "string") {
      //     console.log("BUCKET LINK DETECTED");
      //     return { ...newData, image: elem?.image, isDeleted: true };
      //   }
      return newData;
    }
    return elem;
  });
}

export function isValidUrl(string) {
  try {
    new URL(string);
    return true;
  } catch (err) {
    return false;
  }
}

export const lowerCaseAndAddHyphen = (text, isLower) => {
  if (isLower) {
    return text?.toLowerCase()?.replaceAll(" ", "-");
  }
  return text?.replaceAll(" ", "");
};

export const makeStatusKey = (text) => {
  return text?.replaceAll(" ", "_");
};

export const getImageUrl = (img, slug) => {
  if (!img) return;
  if (slug) return `${imgURL}${slug}${img}`;
  return `${imgURL}${img}`;
};

export function isFileObject(object) {
  return object instanceof File;
}

// Add Hyphen Between Words
export function addHyphenBetweenWords(text) {
  return text?.split(" ")?.join("-");
}

export function removeUnderscoreBetweenWords(text) {
  return text?.replaceAll("_", " ");
}

export function capitalizeText(str) {
  return str
    ?.split(" ")
    ?.map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    ?.join(" ");
}

export function addSpaceBetweenShopOwner(text, capitalize = false) {
  const lowerCaseText = text?.toLowerCase();
  if (lowerCaseText === roles.SHOPOWNER) {
    if (capitalize) {
      return capitalizeText(text?.slice(0, 4) + " " + text?.slice(4));
    }
    return text.slice(0, 4) + " " + text.slice(4);
  } else {
    if (capitalize) {
      return capitalizeText(removeUnderscoreBetweenWords(text));
    }
    return removeUnderscoreBetweenWords(text);
  }
}

/* 
 To check only if a property exists, without getting its value. It similer get function.
*/
export function has(obj, key) {
  return key.split(".").every(function (x) {
    if (typeof obj !== "object" || obj === null || x in obj === false)
      /// !x in obj or  x in obj === true *** if you find any bug
      return false;
    obj = obj[x];
    return true;
  });
}

/* 
 convert indexes to properties
*/
export function valueByString(obj, string, devider) {
  if (devider === undefined) {
    devider = "|";
  }
  return string
    .split(devider)
    .map(function (key) {
      return get(obj, key);
    })
    .join(" ");
}

/*
 Submit multi-part form using ajax.
*/
export function toFormData(form) {
  let formData = new FormData();
  const elements = form.querySelectorAll("input, select, textarea");
  for (let i = 0; i < elements.length; ++i) {
    const element = elements[i];
    const name = element.name;

    if (name && element.dataset.disabled !== "true") {
      if (element.type === "file") {
        const file = element.files[0];
        formData.append(name, file);
      } else {
        const value = element.value;
        if (value && value.trim()) {
          formData.append(name, value);
        }
      }
    }
  }

  return formData;
}

export const navigateToPage = (pathname, state, navigate) => {
  if (pathname) {
    navigate(pathname, { state });
  }
};

// export const formatTimeTo12Hour = (isoDateTime) => {
//   const date = new Date(isoDateTime);

//   // Use Intl.DateTimeFormat for formatting
//   const options = {
//     hour: 'numeric',
//     minute: 'numeric',
//     hour12: true, // Ensures 12-hour format
//   };

//   return new Intl.DateTimeFormat('en-US', options).format(date);
// };

export const formatTimeTo12Hour = (isoDateTime) => {
  if (!isoDateTime || isNaN(Date.parse(isoDateTime))) {
    console.error("Invalid ISO date string:", isoDateTime);
    return "Invalid date";
  }

  const date = new Date(isoDateTime);

  const options = {
    hour: "numeric",
    minute: "numeric",
    hour12: true,
  };

  return `${readableDate(isoDateTime)}  ${new Intl.DateTimeFormat(
    "en-US",
    options
  ).format(date)}`;
};

// Display user name on message & activity tabs
export const showUserName = (user, loggedInUser) => {
  if (
    user?.role?.name === loggedInUser?.role &&
    user?.name === loggedInUser?.name
  ) {
    return "You";
  }
  return user?.name;
};

// Format ClaimNumber
export const formatClaimNumber = (claimNumber) => {
  if (!claimNumber) return "";

  return claimNumber.replace(/(\d{5})(\d{8})(\d{5})/, "$1 $2 $3");
};

export const showActivityUserName = (user, loggedInUser) => {
  if (user?.name === loggedInUser?.name) {
    return "You";
  }
  return user?.name;
};

// format date in this format => April 28, 2022
export const readableDate = (dateString) => {
  const date = new Date(dateString);

  const options = { year: "numeric", month: "long", day: "numeric" };
  return date.toLocaleDateString("en-US", options);
};

export function bytesToMB(sizeInBytes) {
  return (sizeInBytes / (1024 * 1024)).toFixed(2); // Convert bytes to MB and format to 2 decimal places
}

export const lastUpdateDate = (history) => {
  const data = history[history.length - 1];
  return readableDate(data?.timestamp);
};

export const errorMessage = (text) => message.error(text);

/*
 Format Date to display admin
*/
export function formatDate(param) {
  const date = new Date(param);
  let day = date.getDate().toString();
  let month = (date.getMonth() + 1).toString();
  const year = date.getFullYear();
  if (month.length < 2) month = `0${month}`;
  if (day.length < 2) day = `0${day}`;
  const fullDate = `${day}/${month}/${year}`;
  return fullDate;
}

// FORMATS BREADCRUMBS
export function formatBreadcrumb(crumbs) {
  const splitedCrumbs = crumbs.split("-");
  if (splitedCrumbs.length > 0) {
    const formatedCrumbs = splitedCrumbs
      .map((item) => item[0].toUpperCase() + item.slice(1))
      .join(" ");
    return formatedCrumbs;
  }
  return crumbs[0].toUpperCase();
}

/*
 Format Datetime to display admin
*/
export function formatDatetime(param) {
  let time = new Date(param).toLocaleTimeString();
  return formatDate(param) + " " + time;
}

/*
 Set object value in html
*/
export function bindValue(obj, parentElement) {
  parentElement.querySelectorAll("[data-property]").forEach((element) => {
    const type = element.dataset.type;
    let value = valueByString(obj, element.dataset.property);
    console.log({ type });
    switch (type) {
      case "date":
        value = formatDate(value);
        break;

      case "datetime":
        value = formatDatetime(value);
        break;

      case "currency":
        value = value.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
        break;

      default:
        break;
    }
    element.innerHTML = value;
  });
}

export const formatHours = (hours) => {
  return Number(hours).toFixed(2);
};

export const formatToDecimalTwoPoints = (text) => {
  return Number(Number(text).toFixed(2)).toLocaleString();
};

export function formatNumber(input) {
  if (typeof input !== "number" || isNaN(input)) {
    return "Invalid input";
  }

  return Number.isInteger(input) ? input : parseFloat(input.toFixed(1));
}

export function getRandomHexColor() {
  return (
    "#" +
    Math.floor(Math.random() * 16777215)
      .toString(16)
      .padStart(6, "0")
  );
}

export const getFileLogo = (file) => {
  if (file.type.startsWith("image/")) return null;
  if (file.type === "application/pdf") return fileLogos.pdf;
  if (file.type === "text/plain") return fileLogos.text;
  if (
    file.type === "application/msword" ||
    file.type ===
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
  ) {
    return fileLogos.document;
  }
  if (
    file.type === "application/vnd.ms-excel" ||
    file.type ===
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
  ) {
    return fileLogos.sheet;
  }
  return fileLogos.default;
};

export const formatDayjsDate = (dayjsDate) => {
  let _date = dayjsDate ? dayjsDate.format("YYYY-MM-DD") : null;
  return _date;
};

const getMonthRangeFromDate = (date) => {
  const lastDate = dayjs(date).add(1, "day");
  const firstDate = lastDate.subtract(30, "days");
  return { firstDate, lastDate };
};

const getYearRangeFromDate = (date) => {
  const yearLastDate = dayjs(date);
  const yearFirstDate = lastDate.subtract(2, "year");
  return { yearFirstDate, yearLastDate };
};

const currentDate = dayjs();
export const { firstDate, lastDate } = getMonthRangeFromDate(currentDate);
export const { yearFirstDate, yearLastDate } =
  getYearRangeFromDate(currentDate);

export const truncateValues = (text, maxLength = 25) => {
  return text?.length > maxLength ? text?.slice(0, maxLength) + "..." : text;
};

export function getYearLabels(startYear) {
  const currentYear = new Date().getFullYear();
  const years = [];

  for (let year = currentYear; year >= startYear; year--) {
    years.push({ label: year.toString(), value: year });
  }

  return years;
}

export function sortingDataHelper(sortingArray, sortOrder, sortField) {
  return [...(sortingArray ?? [])].sort((a, b) => {
    return sortOrder === "ascend"
      ? a[sortField] - b[sortField]
      : b[sortField] - a[sortField];
  });
}

export function extractFileName(url) {
  return decodeURIComponent(url.substring(url.indexOf("_") + 1));
}

export function generateHoursList() {
  return Array.from({ length: 99 }, (_, i) => ({
    value: i + 1,
    label: `${i + 1}`,
  }));
}

export function generateDayHoursList() {
  return Array.from({ length: 99 }, (_, i) => ({
    value: (i + 1) * 24,
    label: `${i + 1}`,
  }));
}

export function generateReminderCountList() {
  return Array.from({ length: 10 }, (_, i) => ({
    value: i + 1,
    label: `${i + 1} ${i + 1 === 1 ? "reminder" : "reminders"}`,
  }));
}

export function returnHoursOrDaysList() {
  return [
    {
      value: "hours",
      label: "hours",
    },
    {
      value: "days",
      label: "days",
    },
  ];
}

export function timeDifference(dateTimeString) {
  const givenDate = new Date(dateTimeString);
  const currentDate = new Date();
  const diffInMs = currentDate - givenDate;
  const diffInHours = diffInMs / (1000 * 60 * 60);

  if (diffInHours > 24) {
    const diffInDays = diffInHours / 24;
    if (diffInDays > 30) {
      return `${Math.ceil(diffInDays / 30)} months`;
    }
    return `${Math.ceil(diffInDays)} days`;
  }

  return `${Math.ceil(diffInHours)} hours`;
}

export function formatInsuranceData(data) {
  return data?.map((item) => ({
    label: item?.insuranceName,
    value: item?._id,
  }));
}

export function generateNumbers(number) {
  return Array.from({ length: number }, (_, i) => ({
    value: i + 1,
    label: i + 1,
  }));
}

export const convertToHours = (timeObj) =>
  timeObj?.unit === hourDayEnum.days
    ? { value: timeObj?.value * 24, unit: timeObj?.unit }
    : timeObj;

export const convertHoursToDays = (timeObj) =>
  timeObj?.unit === hourDayEnum.days
    ? { value: timeObj?.value / 24, unit: timeObj?.unit }
    : { value: timeObj?.value, unit: timeObj?.unit };

export const updateLocalStorage = (user) => {
  const _localStorage = { ...JSON.parse(localStorage.getItem("auth")) };
  let _current = { ..._localStorage?.current };
  let _user = { ..._current?.user };
  _user = {
    ..._user,
    name: user?.name,
    phone: user?.phone,
    profileImage: user?.profileImage,
  };
 
  _current.user = _user;
  _localStorage.current = _current;
  localStorage.setItem("auth", JSON.stringify(_localStorage));
  store.dispatch({
    type: actionTypes.LOGIN_SUCCESS,
    payload: _current,
  });
  store.dispatch({
    type: actionTypes.SHOP_PROFILE,
    payload: storePersist.get("auth")?.shopProfile,
  });
};

export const confirmModalPreviewMethod = ({
  title,
  icon,
  content,
  onConfirmFunction,
}) => {
  confirm({
    title,
    icon: icon || <ExclamationCircleOutlined />,
    content,
    okButtonProps: {
      style: {
        backgroundColor: "#f36c28",
      },
    },
    cancelButtonProps: {
      className: "confirmation-cancel-btn",
    },
    async onOk() {
      try {
        onConfirmFunction();
      } catch (error) {
        console.error("Error In Confirmation: ", error);
      }
    },
  });
};

export const truncate = (text, len = 27) =>
  text?.length > len ? text.slice(0, len) + "..." : text;
